export const appColor = {
  // その他。共通
  App: {
    primary: "#464BA8",
    accent: "#DE3E44",
    gray: "#BDBDBD",
    white: "#FFFFFF",
    red: "#DB3737",
  },
  Text: {
    primary: "#222222", // 主にメインテキストなどに使用
    secondary: "#727171", // 非アクティブ要素や注釈のテキストなどに使用
    white: "#FFFFFF",
    black: "#000000",
    gray: "#717171",
    ghost: "#c6cacd",
    brand: "#464BA8",
    periodic: "#EF8D4A",
    purpleGray: "#858e9f",
    error: "#b20030",
    red: "#EE2D38",
    darkGray: "#656D7E",
    redLine: "#DB3737",
    overcastSky: "#A9B7C4",
    slateBlueGray: "#87909F",
  },
  Border: {
    primary: "#222222", // Divider/Border/Strokeが主にアクティブなときに使用
    secondary: "#F7F7F7", // Divider/Border/Strokeが主に非アクティブなときに使用
    gray: "#000000",
    grayLight: "#DDDDDD",
    grayUltraLight: "#EBEBEE",
    third: "#F1F1F1",
    headerBell: "#D3DBE2",
    purpleGray: "#dcb0ff",
    darkGray: "#A9A9A9",
    brand: "#464BA8",
    periodic: "#EF8D4A",
    red: "#EE2D38",
    paleWhite: "#E4E7EC",
    slateBlueGray: "#87909F",
  },
  Background: {
    primary: "#FBFBFB", // メインバックグラウンドで使用
    secondary: "#F7F7F7", // サブコンテンツのバックグラウンドで使用
    error: "#FFE5E7",
    selected: "#D0D0D0", // リストアイテムなどが選択状態のときに使用
    tertiary: "#F6F7F8", // セレクト状態などで使用月白(げっぱく)
    auth: "#FBFBFB", // Authの背景色
    lightRed: "#DB3737", // ボタンの背景色
    darkblack: "#000000",
    paleWhite: "#E4E7EC",
    white: "#FFFFFF",
    grayLight: "#DDDDDD",
    brand: "#464BA8",
    brandGray: "#D8DDE6",
    brandActive: "#6469C6",
    blur: "#000221",
    purpleGray: "#fcf9ff",
    pink: "#FFE5E7",
    brownLight: "#F0EFE9",
    black: "#222222",
    lightGray: "#F3F4F5",
    redLine: "#DB3737",
    darkGray: "#656D7E",
    lightBlue: "#3391FF",
    paleSkyBlue: "#F3F6FA",

    // アクセント
    blue: "#DEEDFF",
    green: "#CBE5D3",
    greenMain: "#4EDD76",
    yellow: "#F0E4C3",
    red: "#F2CBCB",
    gray: "#DADBDD",
  },
  Form: {
    primary: "#FFFFFF", // 活性状態のときに使用
    secondary: "#F3F4F5", // 非活性状態のときに使用
    error: "#EE2D38",
  },
  Button: {
    primary: {
      color: "#181B1E",
      text: "#FFFFFF",
    }, // メインボタン
    secondary: {
      color: "#FFFFFF",
      text: "#181B1E",
      hover: "#f8f8f8",
    },
    negative: {
      color: "#D6D9DC",
      text: "#D6D9DC",
    }, //主にボタンが非アクティブ状態で使用
    accent: {
      red: "#FF7663",
      gray: "#7F7F89",
      facebook: "#1877F2",
    },
    social: {
      facebook: "#5E6E9F",
    },
  },
  Calendar: {
    weekDayLabel: "#7F7F89",
    availebleCircle: "#DB3737",
    limitedTriangle: "#F4D050",
    reversedIcon: "#FFFFFF",
    disabled: "#A9B7C4",
  },
} as const;
